import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import Modal from './Modal'

export default function ConfirmModal({ isOpen, onClose, onConfirm, title, message, confirmText, cancelText }) {
  const { t } = useTranslation()
  if (!isOpen) return null

  const resolvedConfirm = confirmText ?? t('modal.common.confirm')
  const resolvedCancel = cancelText ?? t('modal.common.cancel')
  const resolvedTitle = title || t('modal.common.confirmActionTitle')

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={resolvedTitle}>
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 text-yellow-600">
          <AlertTriangle className="w-8 h-8" />
        </div>
        <div className="flex-1">
          <p className="text-gray-700">{message}</p>
        </div>
      </div>
      <div className="mt-6 flex justify-end gap-3">
        <button
          onClick={onClose}
          className="btn btn-secondary"
        >
          {resolvedCancel}
        </button>
        <button
          onClick={() => {
            onConfirm()
            onClose()
          }}
          className="btn btn-primary"
        >
          {resolvedConfirm}
        </button>
      </div>
    </Modal>
  )
}
